module.exports = __webpack_public_path__ + "img/job-fair-bg.f9565326.png";